export default __webpack_public_path__ + "static/logo_2-4724cb44e8b217d2aca238bcdb797588.svg";